/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Swatches(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M228.16846,152.95605,209.01514,100.334a16.0165,16.0165,0,0,0-20.50733-9.56347l-59.94262,21.81738,11.0769-62.82031a16.00057,16.00057,0,0,0-12.97852-18.53613L71.51514,21.50879A15.99894,15.99894,0,0,0,52.979,34.48633L28.792,171.65918a45.288,45.288,0,0,0,7.74365,33.9834A43.299,43.299,0,0,0,71.937,223.99707h.00342c.02014,0,.03955.00293.05957.00293H212a16.01833,16.01833,0,0,0,16-16V164.27759A15.91483,15.91483,0,0,0,228.16846,152.95605ZM72,192a12,12,0,1,1,12-12A12.01343,12.01343,0,0,1,72,192Zm140,16H123.71875L212,175.86841Zm-98.54736-13.29053a43.46748,43.46748,0,0,0,1.8789-7.06885l10.02552-56.85791L193.98,105.80566l19.15332,52.623Z" />
    </Svg>
  );
}

export default Swatches;
